/**
 * MotionDeleteModal — confirm dialog for the Motion List multi-select delete.
 *
 * Deleting a Motion is IRREVERSIBLE and CASCADES (backend removes the Motion's
 * work pools / waves / asset links in one transaction), so the delete is gated
 * behind this explicit confirm listing exactly which Motions will go. The actual
 * delete = N parallel DeleteMotion calls in the parent (no batch op).
 */

import { Alert, Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import type { MotionListItem } from '../../../client/IvtHubClient';

interface MotionDeleteModalProps {
  motions: MotionListItem[];
  deleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function MotionDeleteModal({ motions, deleting, onConfirm, onCancel }: MotionDeleteModalProps) {
  const n = motions.length;
  return (
    <Modal
      visible
      onDismiss={() => {
        if (!deleting) onCancel();
      }}
      header={`删除 ${n} 个 Motion`}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onCancel} disabled={deleting}>
              取消
            </Button>
            <Button variant="primary" onClick={onConfirm} loading={deleting}>
              删除
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Alert type="warning">
          删除不可撤销，会同时删除这些 Motion 的工作池（pool）、Wave 和 Asset 关联。
        </Alert>
        <div>
          将删除以下 {n} 个 Motion：
          <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
            {motions.map((m) => (
              <li key={m.motionId ?? m.name}>{m.name ?? m.motionId}</li>
            ))}
          </ul>
        </div>
      </SpaceBetween>
    </Modal>
  );
}
